import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import { useSelector } from 'react-redux'

import { newPermissionInfo } from '../../../tools/mockData'
import { IRootState } from '../../redux/reducers'

import { UsagePermissionsInfo } from './types'
import UsagePermissionForm from './UsagePermissionsForm'

type EditUsagePermissionPageProps = {
  match: {
    params: {
      slug: string
    }
  }
  history: {
    push: (path: string) => void
  }
}

const EditUsagePermissionPage = ({
  match,
  history,
}: EditUsagePermissionPageProps) => {
  const usagePermissions: UsagePermissionsInfo[] = useSelector(
    (state: IRootState) =>
      state.usagePermissions != null
        ? state.usagePermissions.usagePermissions
        : [],
  )

  const usagePermissionsStr = '/usagepermissions'
  if (usagePermissions.length === 0) {
    history.push('/')
  }

  const [entity, setEntity] = useState<UsagePermissionsInfo>(newPermissionInfo)
  const [showModal, setShowModal] = useState(true)
  const handleCancel = () => setShowModal(false)

  useEffect(() => {
    const rowEntity = usagePermissions.find(
      (entity: UsagePermissionsInfo) => entity.id === match.params.slug,
    )
    if (rowEntity == null) return
    setEntity(rowEntity)
  }, [match.params.slug, usagePermissions])

  const handleExited = () => {
    history.push(usagePermissionsStr)
  }

  return (
    <Modal
      show={showModal}
      onHide={handleCancel}
      onExited={handleExited}
      backdrop="static"
      keyboard={false}
    >
      <div className="container">
        <UsagePermissionForm
          entityData={entity}
          history={history}
          onClose={handleCancel}
        />
      </div>
    </Modal>
  )
}

export default EditUsagePermissionPage
